import script from "./AboutPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutPage.vue?vue&type=script&setup=true&lang=js"

import "./AboutPage.vue?vue&type=style&index=0&id=0c2e6dfe&lang=scss"

const __exports__ = script;

export default __exports__